<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.fabric_label_groupSpecName') || '规格名称'"
            prop="groupSpecName"
          >
            <dict-select
              :disabled="disabled"
              v-model="formData.groupSpecName"
              url="factory/changeOrderDemandFabric/selectGroupSpecName"
              :body="{ changeOrderCode: changeOrderCode }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.fabric_label_fabricPositionName') || '面料位置'"
            prop="fabricPositionName"
          >
            <dict-select
              v-if="addType !== 'batchAdd'"
              v-model="formData.fabricPositionCode"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricPosition' }"
              :selectedLabel.sync="formData.fabricPositionName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
              @change="changeFabic"
            ></dict-select>
            <dict-select
              v-if="addType === 'batchAdd'"
              v-model="fabricPositionList"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricPosition' }"
              :options="{ label: 'label', value: 'this' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              multiple
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_fabricNo') || '面料编号'"
            prop="fabricNo"
          >
            <el-input v-model="formData.fabricNo" readonly :size="'small'">
              <el-button
                :disabled="disabled"
                slot="append"
                icon="el-icon-finished"
                @click="() => (fabricDialogVisible = true)"
              ></el-button>

              ></el-input
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item
            :label="$l('INDEX.form_label_fabricDisplayName') || '面料显示名称'"
            prop="fabricDisplayName"
          >
            <el-input
              v-model="formData.fabricDisplayName"
              readonly
              :size="'small'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeight') || '克重'"
            prop="weight"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              size="small"
              :min="0"
              :step="1"
              v-model="formData.weight"
              :disabled="formData.fabricPositionName !== '填充'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeightUnit') || '克重单位'"
            prop="fabricWeightUnit"
          >
            <dict-select
              v-model="formData.fabricWeightUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricWeightUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
              :disabled="formData.fabricPositionName !== '填充'"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="this.$l('INDEX.form_label_isSpecify') || '客户指定供应商'"
            ><br />
            <el-radio-group size="small" v-model="formData.isSpecify">
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <dict-select
              :placeholder="
                $l('INDEX.tips_purchase_form_label_scmCode') || '请选择供应商'
              "
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="this.$l('INDEX.order_form_label_isCustomerProvide') || '客户指定供应商'"
            ><br />
            <el-radio-group size="small" v-model="formData.isCustomerProvide">
              <el-radio label="Y">
                {{ this.$l('INDEX.order_form_label_isCustomerProvide_Y') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.order_form_label_isCustomerProvide_N') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-fabric-dialog
      :title="$l('INDEX.dialog_title_fabric_information') || '添加面料信息'"
      :visible.sync="fabricDialogVisible"
      type="radio"
      @confirm="onFabricConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    code: String,
    changeOrderCode: String,
    addType: String,
  },
  data() {
    return {
      backDialogVisible: false,
      fabricDialogVisible: false,
      fabricPositionList: [],
      formData: {
        isSpecify: 'N',
        isCustomerProvide: 'N',
        fabricNo: '',
        scmCode: '',
        weight: '',
        fabricWeightUnit: '',
      },
      fabricList: [], //批量保存的数据
      rules: {
        groupSpecName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        fabricNo: [
          {
            required: true,
            message: this.$l('form_label_select_fabricNo') || '请选择面料',
            trigger: 'change',
          },
        ],
        fabricPositionName: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.addType !== 'batchAdd') {
                if (!this.formData.fabricPositionCode) {
                  callback(
                    new Error(
                      this.$l('form_label_select_fabricPositionName') ||
                        '请选择面料位置'
                    )
                  )
                } else {
                  callback()
                }
              } else {
                const fabricPositionList = this.fabricPositionList
                if (
                  !fabricPositionList ||
                  fabricPositionList === [] ||
                  fabricPositionList.length <= 0
                ) {
                  callback(
                    new Error(
                      this.$l('form_label_select_fabricPositionName') ||
                        '请选择面料位置'
                    )
                  )
                } else {
                  callback()
                }
              }
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      console.log(this.changeOrderCode)
      if (!this.code) return
      this.$api
        .changeOrderDemandFabricDetailApi({
          changeOrderFabricCode: this.code,
        })
        .then((res) => {
          this.formData = { ...res.body, weight: '', fabricWeightUnit: '' }
          var arr = this.formData.fabricWeight.split(' ')
          this.formData.weight = arr[0] ? arr[0] : ''
          this.formData.fabricWeightUnit = arr[1] ? arr[1] : ''
        })
    },
    async save() {
      this.formData.fabricWeight =
        this.formData.weight + ' ' + this.formData.fabricWeightUnit
      if (this.addType === 'batchAdd') {
        this.batchSave()
      } else {
        this.singleSave()
      }
    },
    async singleSave() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      if (!this.formData.fabricPositionCode) {
        this.$message({
          showClose: true,
          message: '请选择面料位置',
          type: 'error',
        })
        return
      }

      this.loadingOpen()
      //调用保存接口
      this.$api
        .changeOrderDemandFabricSaveApi({
          ...this.formData,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async batchSave() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      if (
        this.fabricPositionList == undefined ||
        this.fabricPositionList.length <= 0
      ) {
        this.$message({
          showClose: true,
          message: '请选择面料位置',
          type: 'error',
        })
      }
      // 提交的传参
      let param = {
        changeOrderCode: this.changeOrderCode,
        fabricList: [],
      }
      let templist = []
      this.fabricPositionList.forEach((item) => {
        let positionCode = item.value
        let positionName = item.label

        let temp = {
          ...this.formData,
          fabricPositionCode: positionCode,
          fabricPositionName: positionName,
        }
        templist.push(temp)
      })
      param.fabricList = templist
      this.loadingOpen()
      // 调用批量保存接口
      this.$api
        .changeOrderDemandFabricBatchSaveApi(param)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onFabricConfirm(data) {
      if (!data) return
      this.formData.fabricCode = data.fabricCode
      this.formData.fabricNo = data.fabricNo
      this.formData.fabricDisplayName =
        data.fabricName + ' ' + data.fabricContent
      this.formData.weight = data.fabricWeight
      this.formData.fabricWeightUnit = data.fabricWeightUnit
      this.formData.fabricWidth = data.Wid
      this.formData.fabricUnit = data.fabricUnit
      this.formData.scmCode = data.supCode
    },
    changeFabic() {
      if (this.formData.fabricPositionCode === '07') {
        if (!this.formData.fabricWeightUnit) {
          this.formData.fabricWeightUnit = 'g'
        }
      }
    },
  },
}
</script>
